import React from 'react';
import s from './Days.module.scss';
import {GlobalImageSelector} from "../../../assets/images/icons/global/GlobalImageSelector";


export const Card = ({forecast, forecastDays}: any) => {
    const { temperature_2m_max, temperature_2m_min, uv_index_max, windspeed_10m_max, weathercode } = forecast.daily;
    const cardData = temperature_2m_max.map((tempMax: any, index: any) => {
        return {
            temperature_2m_max: tempMax,
            temperature_2m_min: temperature_2m_min[index] ?? '',
            uv_index_max: uv_index_max[index] ?? '',
            windspeed_10m_max: windspeed_10m_max[index] ?? '',
            forecastDay: forecastDays[index],
            weathercode: weathercode[index]
        };
    });
    return (
        <>
            {cardData.map((card: any, index: any) => (
                <div className={s.card} key={index}>
                    <div className={s.day}>{card.forecastDay}</div>
                    <GlobalImageSelector id={card.weathercode}/>
                    <div className={s.temp__day}>{Math.round(card.temperature_2m_max)}°</div>
                    <div className={s.temp__night}>Night: {Math.round(card.temperature_2m_min)}°</div>
                    <div className={s.info}>UV index: {card.uv_index_max}</div>
                    <div className={s.info}>Wind: {card.windspeed_10m_max} m/s</div>
                </div>
            ))}
        </>


    );
};
